import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomFormControlDefinition } from '@mpt-fo/common/shared/utils/custom-form-control';
import { PasswordInput, PasswordValidatorType } from '@mpt-fo/common/kamona/components/kamona-input-field/kamona-input-field.component';
import { CountdownType } from '@mpt-fo/common/kamona/components/otp-count-down/otp-count-down.component';
import { IdentityProvider, KamonaFormButtonType, OtpResentMode } from '@mpt-fo/common/kamona/model/kamonal-model';
import { LoginHelperService } from '@mpt-fo/common/core/services/login-helper.service';
import { ActivateDeviceRequestModel } from '@mpt-fo/common/shared/models/device.model';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { MessageType } from '@mpt-fo/common/shared/models/utility.model';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { AuthorizedUser } from '@mpt-fo/common/core/services/authorized-user.service';
import { MessageModalComponent } from '../message-modal/message-modal.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import { Router } from '@angular/router';
import { ErrorCode } from '@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model';
import { Authentication2FAMixpanelSteps, AuthenticationEvents, DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { TwoFactorAuthenticationOtpValidateResponse, TwoFactorAuthenticationStartResponse } from '@mpt-fo/common/shared/models/two-factor-authentication.model';
import { AuthenticationType2FA } from '@mpt-fo/common/shared/models/authentication-method.enum';
import { logger } from '@mpt-fo/common/telemetry';
import { SettingsService } from '@mpt-fo/common/core/services/settings.service';
import { Otp, TwoFactorGenerationPayload } from '@mpt-fo/common/shared/models/otp.model';
import { OnboardingV2Service } from '@mpt-fo/common/core/services/onboarding-v2.service';
import { AuthenticationType } from '@app/channels/settings/profile/components/authentication-methods/authentication-method/models/authentication-method.enum';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';
import { ProfileSetupService } from '@mpt-fo/common/core/services/profile-setup/profile-setup.service';
import { ClusterManagerManagementService } from '@mpt-fo/common/core/services/cluster-manager-management/cluster-manager-management.service';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';
import { LivelinessErrorCode } from '@mpt-fo/common/core/services/liveliness.service';

@Component({
	selector: 'app-login-device-registration',
	templateUrl: './login-device-registration.component.html',
	styleUrls: ['./login-device-registration.component.scss'],
})
export class LoginDeviceRegistrationComponent implements OnInit {
	otpResponse: any;
	otpControl: CustomFormControlDefinition;
	kamonaDialogButtonType: KamonaFormButtonType = KamonaFormButtonType.DOUBLE_BUTTON;
	otp: PasswordInput;
	form: FormGroup;
	countdownType: CountdownType = CountdownType.KAMONA;
	readonly TRANSACTION_PIN_LENGTH = 6;
	ussdCode: any;
	otpSuspensionReleaseTime: any;
	submitting: boolean;

	runningModal: NzModalRef;
	useOtp = false;
	livelinessCheckReference = '';
	identityProvider = IdentityProvider.METAMAP;
	readonly feature = 'DEVICE_REGISTRATION';

  verificationMethod: any;
  twoFactorOrder = [];
  twoOrderByLiveliness = false;
  validationKey = "";
  loading = false;
  PHONE_NUMBER_LOGIN_TYPE = 'PHONENUMBER';
  isLivelinessVerificationDone = false;
  useNewDesignOtpWhatsappUssdDeviceRegistration = false;
  confirmingOtp = false;
  currentOtpModes = OtpResentMode;
  useResendOtpViaWhatsapp: boolean;
  useResendOtpViaSms: boolean;
  showBothCountDown = false;
  canUseNewUssd: boolean;
  currentOTPMode: OtpResentMode;
  hasResendButtonCountdown = false;
	constructor(
		private fb: FormBuilder,
		private loginHelper: LoginHelperService,
		public auth: AuthenticationService,
		private router: Router,
		public user: AuthorizedUser,
		private modal: ModalService,
		private deviceHelper: DeviceHelperService,
		public dataLayerService: DataLayerService,
    private settingsService : SettingsService,
    private modalHelperService : OnboardingV2Service,
    public config: AppConfig,
    private clusterManagerService: ClusterManagerManagementService,
    private profileSetupService: ProfileSetupService,
    private locationHelper: LocationHelper,
	) {}

	ngOnInit(): void {
		this.otpResponse = this.loginHelper.loginOtpResponse;
		if (!this.otpResponse) {
			this.goBack();
			return;
		}
    this.setOTPConfig();
		this.setOtpForm();
    if (this.is2FAEnabled) {
      const response = this.loginHelper?.loginOtpResponse?.responseData;
      this.handleRegistringDeviceResponse(response)
      return;
    }
		this.livelinessCheckReference = this.otpResponse.reference || '';
		this.useOtp = this.otpResponse.code !== ErrorCode.LIVELINESS_REQUIRED;
    this.verificationMethod = this.useOtp ? AuthenticationType.OTP : AuthenticationType.FACE_MATCH_CHECK;
		if (!this.useOtp) {
			this.identityProvider = this.otpResponse.provider || IdentityProvider.METAMAP;
		}
    const step = this.useOtp ? Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED : Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_STARTED;
		this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, step));
	}

  setOTPConfig(){
    const whatsAppConfig = this.config.USE_OTP_WHATSAPP_DEVICE_REGISTRATION;
    this.useNewDesignOtpWhatsappUssdDeviceRegistration = this.config.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION;
    this.useResendOtpViaWhatsapp = whatsAppConfig;
    this.useResendOtpViaSms = this.isSmsEnabled;
	  this.canUseNewUssd = false; //this.profileSetupService.canUseNewUssd();
    this.showBothCountDown = this.useResendOtpViaWhatsapp && this.isSmsEnabled;
    if(!this.is2FAEnabled && this.useResendOtpViaWhatsapp){
      this.setOtpModeWhatsapp();
    }
  }

  get isSmsEnabled() {
    return this.config.SEND_SMS_OTP_2FA;
  }

  async getEventData(errorDetails?: { errorCode?: string; errorMessage: string; }, step= '') {
    const geoHeaders = await this.locationHelper.getCoordinates();

		return {
			auth_type: this.verificationMethod,
			auth_type_provider: this.getAuthTypeProvider(),
			feature: this.feature,
      step:step,
      ...(geoHeaders ? {
				longitude: geoHeaders.longitude,
				latitude: geoHeaders.latitude,
			} : {}),
			...(errorDetails ? {
				api_error_code: errorDetails.errorCode,
				api_error_message: errorDetails.errorMessage,
				error_message: errorDetails.errorMessage,
			} : {}),
		};
	}

  getAuthTypeProvider() {
    if (!this.isLivelinessVerificationDone) {
      return (this.verificationMethod === AuthenticationType2FA.OTP ? AuthenticationType2FA.OTP : this.identityProvider)
    }
    return '';
  }

	setOtpForm() {
		this.otp = new PasswordInput(null, 'Enter OTP', true, PasswordValidatorType.PIN, this.TRANSACTION_PIN_LENGTH);
		this.otp.showPasswordHint = false;
		this.otp.setCanShowError(false);
		this.form = this.fb.group({
			otp: this.otp.getFormGroupControl(),
		});
	}

  set2FAParams(params) {
    params.reference = this.livelinessCheckReference;
    params.otpValidationKey = this.validationKey;
  }

  setOtpParams(params, param) {
    if (this.useOtp) {
      params.otp = param?.otp;
    } else {
      params.reference = this.livelinessCheckReference;
    }
  }


	buildActivateDeviceObj(param) {
		const credentials = this.user.loginCredentials;
		const deviceInformation = this.getDeviceInformation();
		const params = new ActivateDeviceRequestModel(credentials);
		params.deviceUniqueIdentifier = deviceInformation?.deviceUniqueIdentifier;
    if (this.is2FAEnabled) {
      this.set2FAParams(params);
    } else {
      this.setOtpParams(params, param);
    }
		if(this.loginHelper.isNewStaffLogin() && this.loginHelper.staffUserTokenData() && this.loginHelper.staffUserTokenData().businesses?.length > 0){
			params.businessId = this.loginHelper.staffUserTokenData().businesses[0].businessId;
			params.refreshToken = this.loginHelper.staffUserTokenData().tokenData?.refresh_token;
		}
		params.activationToken = param?.response?.identifier;
		params.identifier = param?.response?.identifier;
		return params;
	}

	getDeviceInformation(){
		return this.deviceHelper.getDeviceInformation();
	}

	activateDevice() {
		this.submitting = true;
		const form = this.form.value;
		const param = {
			otp: form?.otp,
			response: this.otpResponse,
		};
		const deviceInformation = this.getDeviceInformation();
		const params = this.buildActivateDeviceObj(param);
    const apiCall = this.is2FAEnabled ? this.auth.activateDeviceOnLoginV2(params) : this.auth.activateDeviceOnLogin(params);
		apiCall
			.then((res) => {
				if (this.useOtp) {
					this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.DEVICE_ACTIVATION_SUCCESS));
				}
				if(this.loginHelper.isNewStaffLogin() && res.businesses){
					this.loginHelper.setStaffBusinesses(res.businesses);
				}
				this.loginHelper.processSessionUser(res, deviceInformation);
			})
			.catch((err) => {
				this.submitting = false;

        if (err?.error?.responseCode === ErrorCode.CLUSTER_MANAGER_USER_LOGIN) {
          this.loginHelper.saveClusterManagerUserTokenData(
            (this.clusterManagerService.isClusterManagerUser(err) ? err?.error.tokenDataDeviceResponse : err?.error),
            err?.error?.code === ErrorCode.CLUSTER_MANAGER_USER_LOGIN
          );
          return;
        }

				const restartProcess = err?.error?.responseCode === LivelinessErrorCode.LIVELINESS_REFERENCE_CONSUMED;
        
				const errorMessage = StringHelper.getErrorMessageHttpErrorResponse(err);
				if (this.useOtp) {
					this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
						errorCode: err?.error?.responseCode,
						errorMessage,
					}, Authentication2FAMixpanelSteps.DEVICE_ACTIVATION_FAILED));
				}
				const errParams = {
					title: 'Device Registration Failed',
					description: errorMessage || 'An Error occurred',
					messageType: MessageType.ERROR,
					useFullButton: true,
					callback: () => {
						this.handleOncloseModal();
						if(restartProcess) {
              this.router.navigateByUrl('/login');
						}
					},
				};
				this.launchMessageModal(errParams);
			});
	}

	createModalConfig(params) {
		const config = new ModalOptionsConfig();
		config.nzWidth = 396;
		config.nzComponentParams.data = params;
		config.nzComponentParams.callback = params?.callback;
		return config;
	}

	handleOncloseModal() {
		this.runningModal.destroy();
	}

	launchMessageModal(params) {
		const config = this.createModalConfig(params);
		this.runningModal = this.modal.createModal(MessageModalComponent, config);
	}

	goBack() {
		if (!this.submitting) {
			this.router.navigateByUrl('/login');
		}
	}

	retryOtp() {
    if(this.is2FAEnabled){
      this.generateOTP2FA();
      return;
    }
		this.goBack();
	}

	livelinessStepCompleted($evt) {
		if ($evt === -1) {
			this.goBack();
			return;
		}
    this.isLivelinessVerificationDone = true;
    if (this.is2FAEnabled) {
      this.handle2FAFlow();
    } else {
      this.activateDevice();
    }
	}

  isTwoFactorAuthentication(): boolean {
    return this.verificationMethod === AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION;
  }

  activateDeviceV2(){
    if(this.is2FAEnabled){
      this.validateOtp2FA({otp : this.form.value.otp});
    } else {
      this.activateDevice();
    }
  }

  activateDeviceV3(event){
    this.form.get('otp').setValue(event?.otp);
    this.activateDeviceV2();
  }

  handleOtpResponse(event) {
    this.validateOtp2FA(event);
  }

  async validateOtp2FA($event: Otp) {
    this.submitting = true;
    let payload = this.buildValidateOtpPayload($event?.otp);
    payload = {...payload, authenticationPurpose: this.feature};
    try {
      this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED));
      const res = await this.settingsService.ValidateOtp2FA(payload);
      this.handleOtpValidationSuccess(res);
      this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_SUCCESS));
    } catch (error) {
      this.submitting = false;
      this.handleOtpValidationError(error);
      this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
        errorCode: error?.error?.code,
        errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
      }, Authentication2FAMixpanelSteps.VALIDATE_OTP_FAILED));
    }
  }

  buildValidateOtpPayload(otp: string){
		let payload = this.buildPayload();
		payload = {...payload, otp};
		return payload;
	}

  handleOtpValidationError(error) {
    logger.error('error on calling validating otp', error);
    this.showError(error);
  }

  handleOtpValidationSuccess(res: TwoFactorAuthenticationOtpValidateResponse) {
    this.validationKey = res?.validationKey;

    if (this.isTwoFactorAuthentication()) {
      this.handleTwoFactorAuthentication();
    } else {
      this.activateDevice();
    }
  }

  handleTwoFactorAuthentication() {
    if (!this.twoOrderByLiveliness) {
      this.generateReferenceAndSetLivenessStep();
    } else {
      this.activateDevice();
    }
  }

  generateReferenceAndSetLivenessStep() {
    this.generateReference2FA();
    this.useOtp = false;
  }

  handle2FAFlow() {
    if (this.isTwoFactorAuthentication() && this.twoOrderByLiveliness) {
      this.setCurrentStepToOTP();
      this.useOtp = true;
    } else {
      this.activateDevice();
    }
  }

  setCurrentStepToOTP() {
    this.generateOTP2FA();
  }

  buildPayload(): TwoFactorGenerationPayload{
    const userTypePayload = this.settingsService.getUserTypePayload();
	  const usePhoneNumberForRecovery = this.isPhoneNumberLoginType(userTypePayload);
    const value = userTypePayload?.value;
    const payload = usePhoneNumberForRecovery ? {phoneNumber: value} : {username: value};

    return {...payload, authenticationPurpose: this.feature};
  }

  buildPayload2FA(){
    const userTypePayload = this.settingsService.getUserTypePayload();
	  const usePhoneNumberForRecovery = this.isPhoneNumberLoginType(userTypePayload);
    const value = userTypePayload?.value;
    const payload = usePhoneNumberForRecovery ? {mobileNumber: value} : {username: value};

    return {...payload, authenticationPurpose: this.feature};
  }

  isPhoneNumberLoginType(userTypePayload){
	  return userTypePayload?.identityType === this.PHONE_NUMBER_LOGIN_TYPE;
  }

  setOtpModeWhatsapp(){
    if(this.useResendOtpViaWhatsapp && !this.useResendOtpViaSms){
      this.currentOTPMode = OtpResentMode.WHATSAPP_MODE;
    }
  }

  async generateOTP2FA() {
    this.loading = true;
    this.useOtp = true;
    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_STARTED));
    try {
      const payload = this.buildPayload2FA();
      payload['notificationChannel'] = (this.currentOTPMode || OtpResentMode.SMS_MODE)?.split('_')[0];
      const res = await this.settingsService.generateOtp2FAPublic(payload, this.feature);
      this.ussdCode = res?.ussdCode;
      this.otpResponse.message = res.otpMessage;
      this.otpResponse.ussdCode = this.ussdCode;
      this.setOtpModeWhatsapp();
      this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_SUCCESS));
    } catch (error) {
      this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
        errorCode: error?.error?.code,
        errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
      },Authentication2FAMixpanelSteps.GENERATE_OTP_FAILED));
      logger.error('error on calling generate otp', error);
      this.showError(error);
    } finally {
      this.loading = false;
    }
  }


  handleRegistringDeviceResponse(res: TwoFactorAuthenticationStartResponse){
    this.verificationMethod = res.authenticationMethod;
    if(this.verificationMethod !== AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION){
      this.twoFactorOrder = [res.authenticationMethod]
    } else {
      this.twoFactorOrder = res.order;
    }
    this.setSteps(res);
	}

  setSteps(res: TwoFactorAuthenticationStartResponse) {
    this.twoOrderByLiveliness = res.order ? res.order[0] == AuthenticationType2FA.FACE_MATCH : false;
    if (this.is2FAEnabled) {
      this.generate2FA();
    }
  }

  async generate2FA() {
    this.submitting = true;

    try {
      await this.processTwoFactorMethods();
    } catch (error) {
      this.handle2FAError(error);
    } finally {
      this.submitting = false;
    }
  }

  async processTwoFactorMethods() {
    for (const method of this.twoFactorOrder) {
      if (await this.shouldGenerateReference2FA(method)) {
        await this.generateReference2FA();
        break;
      } else if (await this.shouldGenerateOTP2FA(method)) {
        await this.generateOTP2FA();
        break;
      }
    }
  }

  async generateReference2FA() {
    this.loading = true;
    const payload = this.buildPayload2FA();
    const deviceInformation = this.getDeviceInformation();
    try {
      this.dataLayerService.logEventWithData(
        AuthenticationEvents.initiated,
        this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_STARTED)
      );

      const res = await this.settingsService.generateReference2FA(
        {
          ...payload, 
          deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier
        }
      );

      this.livelinessCheckReference = res.reference;
      this.identityProvider = res.provider;
      this.useOtp = false;

      this.dataLayerService.logEventWithData(
        AuthenticationEvents.success,
        this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_SUCCESS)
      );
    } catch (error) {
      this.dataLayerService.logEventWithData(
        AuthenticationEvents.failed,
        this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_FAILED)
      );

      logger.error('Error on calling generate liveliness reference', error);
      this.showError(error);
    } finally {
      this.loading = false;
      this.submitting = false;
    }
  }


  async shouldGenerateReference2FA(method) {
    return method === AuthenticationType2FA.FACE_MATCH && !this.livelinessCheckReference;
  }

  async shouldGenerateOTP2FA(method) {
    return method === AuthenticationType2FA.OTP && !this.ussdCode;
  }

  handle2FAError(error) {
    logger.error('catching error on generate 2fa', error);
    this.showError(error);
  }

  showError(error) {
	  const params = this.getErrorParameters(error);
	  this.launchFailedModal(params?.description, params?.title, params?.callbackName);
  }

  get is2FAEnabled(){
    return this.otpResponse?.responseCode == ErrorCode.TWO_FACTOR_AUTHENTICATION;
  }

  getErrorParameters(error) {
		const title = this.getFailedOtpGenerationTitle(error);
		const callbackName = this.getFailedOtpGenerationCallbackName(error);
		const description = StringHelper.getErrorMessageHttpErrorResponse(error);
		return { title, callbackName, description };
	}
	getFailedOtpGenerationTitle(error: any) {
		const title = this.modalHelperService.isSuspended(error) ?
			'Temporary Suspension' : ''
		return title;
	}

	getFailedOtpGenerationCallbackName(error: any) {
		const callbackName = this.modalHelperService.isSuspended(error) ? 'Dismiss' : ''
		return callbackName;
	}

  launchFailedModal(description, title, callbackName) {
		this.modalHelperService.launchErrorModalV2({ description, callbackName, title })
			.then(() => {
				this.modalHelperService.closeModal();
			});
	}

  reloadOtp(currentMode: OtpResentMode) {
    this.currentOTPMode = currentMode;
    const isUssdResend = currentMode === OtpResentMode.USSD_MODE;
    isUssdResend ? this.handleResendOtpViaUssd()
      : this.generateOTP2FA();
  }

  handleResendOtpViaUssd() {
    this.setConfirmingOtp(true);
  }

  setConfirmingOtp(value: boolean) {
    this.confirmingOtp = value;
  }
}
